import { Component, inject, Input, Output,EventEmitter, OnInit } from '@angular/core';
import { loadScript, PayPalButtonCreateOrder, PayPalButtonOnApprove, PayPalButtonOnError } from "@paypal/paypal-js";
import { environment } from '../../../../environments/environment';
import { EventBookingComplete } from '../../../data-services/models/event-bookings/event-booking-complete.model';
import { PayPalPuchaseUnit } from '../../../data-services/models/paypal/paypal-purchase-units.model';
import { PaymentService } from '../../../data-services/payment.service';
import { Payment, PaymentProviderFields, PaymentProviders } from '../../../data-services/models/payments/payment.model';
import { EventComplete } from '../../../data-services/models/events/event-complete.model';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UserActions } from '../../../data-services/stores/actions/user.actions';
import { PayPalService } from '../../../data-services/paypal.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';


@Component({
  selector: 'app-paypal',
  imports: [],
  templateUrl: '../ui/paypal.component.html',
  styleUrl: '../ui/paypal.component.css'
})
export class PaypalComponent implements OnInit {
  private readonly _paymentService = inject(PaymentService);
  private readonly _router = inject(Router);
  private readonly _store = inject(Store);
  private readonly _paypalService = inject(PayPalService);
  @Input() eventBooking?: EventBookingComplete;
  @Input() event?: EventComplete;
  @Output() paymentTriggered: EventEmitter<any> = new EventEmitter();
  paypalScript: any;

  get ticketTotal(): number {
    return this.eventBooking?.eventTickets.flatMap(x => x.cost).reduce((acc, val) => acc + val, 0) ?? 0
  }

  ngOnInit(): void {
    if (this.eventBooking){
      this._paypalService.getMerchantIds(this.eventBooking?.bookingID!).subscribe(
        merchantId => 
          loadScript({ clientId: environment.paypal.PAYPAL_SANDBOX_CLIENT_ID, currency: 'GBP', merchantId })
            .then((paypal) => {
              if (paypal) {
                paypal
                  .Buttons!({
                    createOrder: () => this.createOrder(),
                    onApprove: this.onApprove(),
                    onError: this.onError(),              
                  })
                  .render("#paypalCheckout")
                  .catch((error) => {
                    console.error("failed to render the PayPal Buttons", error);
                  });
              }
          })
          .catch((error) => {
              console.error("failed to load the PayPal JS SDK script", error);
          })
      )
    }
    
    
  }

  createOrder(): Promise<string>{
    return lastValueFrom(this._paypalService.createOrder(this.eventBooking?.bookingID!))
  }

  // createOrder(): PayPalButtonCreateOrder {
  //   return (data: any, actions: any) => {
  //     this.paymentTriggered.emit('paypal payment window opened');
  //     return actions.order.create({
  //       purchase_units: [{
  //         description: `Event Booking: ${this.eventBooking?.event.name}`,
  //         amount: {
  //           value: this.ticketTotal
  //         },
  //         payee: {
  //           email_address: this.eventBooking?.event.eventHost.paypalAddress
  //         },
  //       }]
  //     })
  //   }
  // }

  onApprove(): PayPalButtonOnApprove {
    return (data: any, actions: any) => {
      return actions.order.capture().then((details: any)=> {
        if (!environment.production){
          console.log('Paypal response', details);
        }
        if (details.status === 'COMPLETED' || details.status === 'PARTIALLY_COMPLETED') {
          let totalPaid:number = 0;
          //const totalPaid = (details.purchase_units as PayPalPuchaseUnit[]).flatMap(x => x.amount.value).reduce((acc, val) => acc + val, 0);
          (details.purchase_units as PayPalPuchaseUnit[]).flatMap(x => x.amount.value).forEach(x => {
            totalPaid += Number.parseFloat(x.toString());
          })

          const payment: Payment = {
            bookingID: this.eventBooking?.bookingID,
            date: new Date(details.create_time),
            value: totalPaid,
            payee: details.payer.email_address,
            eventID: this.event?.eventID,
            accountID: this.eventBooking?.accountID,
            paymentProvider: {
              paymentProviderID: PaymentProviders.PayPal,
            },
            paymentData: [
              {
                paymentProviderFieldID: PaymentProviderFields.OrderID,
                value: details.id
              },
              {
                paymentProviderFieldID: PaymentProviderFields.PaymentID,
                value: details.purchase_units[0].payments.captures[0].id
              },
              {
                paymentProviderFieldID: PaymentProviderFields.ReferenceID,
                value: details.purchase_units[0].reference_id
              }
            ]
          }

          if (!environment.production){
            console.log('Payment data', payment)
          }
          
          this._paymentService.processPayment(payment).subscribe(result =>
          {
            if (this.eventBooking){
              this._store.dispatch(UserActions.loadUser({ refresh: true }))
              this._router.navigate(['account','bookings',this.eventBooking.bookingID])
            }
            else if (this.event){

            }
          });         
        }
      })
    }
  }

  onError(): PayPalButtonOnError {
    return (error: any) => {
      console.error(error);
    }
  }
}
